import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  padding-top: 0.5rem;
  margin-bottom: 5rem;

  scroll-behavior: smooth;
`;

export const ProductInfoParagraph = styled.div`
  h1,
  h2,
  h3,
  p,
  span,
  strong {
    color: ${({ theme }) => theme.colors.grayDark3} !important;
    line-height: 1.5rem !important;
    font-size: 1rem !important;
  }
`;

export const ProductInfoTitle = styled.div`
  color: ${({ theme }) => theme.colors.grayDark4};
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 600;
  line-height: 2.5rem;
  font-family: 'Source Sans Pro';
`;
